var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-modal",
    {
      attrs: {
        "content-css": { maxWidth: _vm.getMaxWidth, minWidth: _vm.getMinWidth },
        "no-backdrop-dismiss": "",
        "no-esc-dismiss": ""
      },
      model: {
        value: _vm.show_preview,
        callback: function($$v) {
          _vm.show_preview = $$v
        },
        expression: "show_preview"
      }
    },
    [
      _c(
        "q-modal-layout",
        [
          _c(
            "q-toolbar",
            { attrs: { slot: "header" }, slot: "header" },
            [
              _c("q-btn", {
                attrs: { flat: "", round: "", dense: "", icon: "fas fa-times" },
                on: {
                  click: function($event) {
                    _vm.show_preview = false
                  }
                }
              }),
              _c("q-toolbar-title", [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t(_vm.game_name)) +
                    "\n            "
                )
              ])
            ],
            1
          ),
          _c("div", { staticClass: "layout-padding" }, [
            _c("div", { staticClass: "row q-pa-xs" }, [
              _c(
                "div",
                { staticClass: "col-12" },
                [
                  _c("p", { staticClass: "text-bold" }, [
                    _vm._v(_vm._s(_vm.$t("game_preview")))
                  ]),
                  _vm._l(_vm.game_words, function(word, index) {
                    return _c(
                      "span",
                      { key: index },
                      [
                        _vm.changeElement(index)
                          ? _c(
                              "q-chip",
                              {
                                staticClass: "word-chip font-bigger q-ma-xs",
                                class: _vm.options[_vm.getInputPosition(index)]
                                  .correct
                                  ? "bg-green-4"
                                  : "bg-red-4",
                                attrs: { square: "", id: "chip-" + index }
                              },
                              [
                                _vm._v(
                                  "\n\n                            " +
                                    _vm._s(
                                      _vm.options[_vm.getInputPosition(index)]
                                        .value
                                    ) +
                                    "\n                            "
                                ),
                                _c("q-icon", {
                                  staticClass: "q-ml-sm",
                                  attrs: {
                                    size: "sm",
                                    name: _vm.options[
                                      _vm.getInputPosition(index)
                                    ].correct
                                      ? "fas fa-check"
                                      : "fas fa-times"
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        word !== "SPECIAL_WORD" && word.includes("\n")
                          ? _c("span", { staticClass: "font-bigger" }, [
                              _c("br"),
                              _vm._v(_vm._s(word + " "))
                            ])
                          : word !== "SPECIAL_WORD"
                          ? _c("span", { staticClass: "font-bigger" }, [
                              _vm._v(_vm._s(word + " "))
                            ])
                          : _c(
                              "span",
                              [
                                _vm.options[_vm.getInputPosition(index)]
                                  .correct === undefined
                                  ? _c("q-input", {
                                      staticClass:
                                        "word-input q-mx-sm bg-grey-2",
                                      style: {
                                        width: _vm.getWordSlotWidth,
                                        background: "red"
                                      },
                                      attrs: {
                                        autocomplete: "off",
                                        "no-parent-field": "",
                                        align: "center",
                                        readonly: _vm.game_finished,
                                        id: "input-" + index
                                      },
                                      on: {
                                        blur: function($event) {
                                          _vm.options[
                                            _vm.getInputPosition(index)
                                          ].value
                                            ? _vm.checkAnswer(index)
                                            : null
                                        }
                                      },
                                      model: {
                                        value:
                                          _vm.options[
                                            _vm.getInputPosition(index)
                                          ].value,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.options[
                                              _vm.getInputPosition(index)
                                            ],
                                            "value",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "options[getInputPosition(index)].value"
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            )
                      ],
                      1
                    )
                  })
                ],
                2
              ),
              _vm.game_finished
                ? _c(
                    "div",
                    { staticClass: "col-10 q-mt-lg" },
                    [
                      _c("p", { staticClass: "text-bold q-mt-sm" }, [
                        _vm._v(_vm._s(_vm.$t("result")))
                      ]),
                      _c("q-slider", {
                        attrs: {
                          disable: "",
                          markers: "",
                          snap: "",
                          color: _vm.game_finished
                            ? _vm.getSliderColor()
                            : "blue-6",
                          min: 0,
                          max: _vm.number_of_choices
                        },
                        model: {
                          value: _vm.user_score,
                          callback: function($$v) {
                            _vm.user_score = $$v
                          },
                          expression: "user_score"
                        }
                      }),
                      _c("p", { staticClass: "q-mt-sm" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("correct_answers") +
                              ": " +
                              _vm.user_score +
                              " / " +
                              _vm.number_of_choices
                          )
                        )
                      ]),
                      _vm.user_won
                        ? _c("p", [_vm._v(_vm._s(_vm.$t(_vm.success_message)))])
                        : _c("p", [_vm._v(_vm._s(_vm.$t(_vm.failure_message)))])
                    ],
                    1
                  )
                : _vm._e()
            ]),
            _c("div", { staticClass: "col-xs-12 q-mt-md" }, [
              _c(
                "div",
                { staticClass: "row justify-end" },
                [
                  _c("q-btn", {
                    attrs: { color: "secondary", label: _vm.$t("back") },
                    on: {
                      click: function($event) {
                        _vm.show_preview = false
                      }
                    }
                  }),
                  !_vm.game_finished &&
                  this.options.filter(function(e) {
                    return e.value
                  }).length === this.options.length
                    ? _c("q-btn", {
                        staticClass: "q-ml-md",
                        attrs: { color: "primary", label: _vm.$t("answer") },
                        on: { click: _vm.checkResults }
                      })
                    : _vm._e(),
                  _vm.game_finished
                    ? _c("q-btn", {
                        staticClass: "q-ml-md",
                        attrs: {
                          color: "primary",
                          label: _vm.$t("play_again")
                        },
                        on: { click: _vm.resetGame }
                      })
                    : _vm._e()
                ],
                1
              )
            ])
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }